import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subject, Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { EntityAlertIconModel, EntityIconDataModel, EntityModel } from 'src/app/model';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-tile-footer',
  templateUrl: './tile-footer.component.html',
  styleUrls: ['./tile-footer.component.css']
})
export class TileFooterComponent implements OnInit, OnDestroy {

  @Input()
  set content(value: EntityModel) {
    this._content = value;
    this._setAlertCount();
    this._setActiveDtcCaseCount();
    this._setIcons();
  }

  get content() {
    return this._content;
  }

  @Input()
  set iconList(value: EntityIconDataModel[]) {
    this._iconListFlag?.next(value);
    this._iconList = value;
  }

  get iconList() {
    return this._iconList;
  }

  // Configuration
  tenantGenericConfig: any = {};
  tenantCategory: string;

  // SAS token
  token: string = ApiConstants.blobSasToken;

  // Alert
  alertCount: number = 0;  
  footerIconList: EntityAlertIconModel[] = [] as EntityAlertIconModel[];
  activeDtcCaseCount: number = 0;

  // Setter variables
  private _iconList: EntityIconDataModel[];
  private _content: EntityModel;

  // Flag
  private _iconListFlag = new Subject<EntityIconDataModel[]>();

  // Subscription
  private _iconListFlagSubscription: Subscription;

  constructor(
    private _router: Router,
    private _sharedService: ServicecallService
  ) {
    // Configuration
    this.tenantGenericConfig = this._sharedService.getConfiguration('tenantGenericConfig') ? this._sharedService.getConfiguration('tenantGenericConfig') : null;
    this.tenantCategory = this._sharedService.getConfiguration('tenantCategory') ? this._sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null;
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._iconListFlagSubscription?.unsubscribe();
  }

  /**
   * Determines whether alert click on
   * @param event
   * @param alertCount
   */
  onAlertClick(event: MouseEvent, alertCount: number) {
    // Stop event propagation
    event?.stopPropagation();
    // Navigate to events page
    if (alertCount) {
      this._router.navigate(['events/alerts', this.content?._id]);
    }
  }

  onDtcClick(event: MouseEvent, dtcCount: number) {
    // Stop event propagation
    event?.stopPropagation();
    // Navigate to DTC page
    if (dtcCount) {
      // this._router.navigate(['dtc/dtcList']);
      this._router.navigateByUrl(`case/caseList?entityName=${this.content?.uniqueId}`);
    }
  }

  /**
   * Sets active dtc case count
   */
  private _setActiveDtcCaseCount() {
    if(this.content?.activeDtcCasesCount) {
      this.activeDtcCaseCount = this.content?.activeDtcCasesCount;
    }
  }

  /**
   * Sets alert count
   */
  private _setAlertCount() {
    if (this.content?.iconDetails?.alerts?.length && this.content?.iconDetails?.alertsCount) {
      this.alertCount = this.content?.iconDetails?.alertsCount ?? 0;
    }
  }

  /**
   * Sets icons
   */
  private _setIcons() {
    this._iconListFlagSubscription = this._iconListFlag
      .subscribe({
        next: (iconList: EntityIconDataModel[]) => {
          if (iconList?.length && this.content?.iconDetails?.alerts?.length && this.content?.iconDetails?.alertsCount) {
            this.footerIconList = [...this.content?.iconDetails?.alerts]?.map(
              (alertIconData) => {
                const iconUrl = iconList?.find((iconData) => iconData?.category === alertIconData?.alert)?.imgUrl;
                return {
                  ...alertIconData,
                  imgUrl: iconUrl
                };
              }
            );
          }
        }
      });
  }
}
